import { render, staticRenderFns } from "./NewSwatchBook.vue?vue&type=template&id=139e3348&scoped=true&"
import script from "./NewSwatchBook.vue?vue&type=script&lang=js&"
export * from "./NewSwatchBook.vue?vue&type=script&lang=js&"
import style0 from "./NewSwatchBook.vue?vue&type=style&index=0&id=139e3348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e3348",
  null
  
)

export default component.exports